<template>
  <div id="app">
    <HeaderAvatar class="fixed-avatar" @changePopup="handlePopupChange" v-if="showHeaderAvatar" />
    <div class="main-content">
      <router-view />
    </div>
    <Profile @changePopup="handlePopupChange" v-if="currentPopup === 'profile'" />

    <button v-if="showPageLogout" class="page-logout" @click="handleLogout">
      <span class="logout-icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 20 24" fill="none">
  <path d="M17.9223 0C19.0698 0 20 0.934362 20 2.08696V18.3001L19.9975 18.4076C19.9435 19.4747 19.0917 20.3305 18.0294 20.3845L17.9223 20.3871H15.8837V21.913L15.8812 22.0205C15.8272 23.0876 14.9754 23.9434 13.9131 23.9975L13.8061 24H2.07766L1.97063 23.9975C1.93709 23.9957 1.90381 23.9926 1.8707 23.9893C1.85832 23.9881 1.84599 23.9867 1.83368 23.9852C1.81073 23.9825 1.78791 23.9795 1.7652 23.9761C1.7511 23.9739 1.7371 23.9713 1.7231 23.9689C1.70596 23.966 1.68885 23.9631 1.67187 23.9597C1.65812 23.957 1.64443 23.9541 1.63078 23.9511C1.60817 23.9461 1.58565 23.941 1.56332 23.9353C1.55532 23.9332 1.54743 23.9308 1.53948 23.9287C1.51802 23.9229 1.49674 23.9168 1.47556 23.9103C1.46316 23.9066 1.45084 23.9026 1.43854 23.8986C1.41641 23.8914 1.39439 23.8841 1.37259 23.8762C1.36337 23.8728 1.35436 23.869 1.3452 23.8655C1.32699 23.8586 1.3089 23.8515 1.29093 23.8441C1.27534 23.8377 1.25966 23.8315 1.24426 23.8247C1.22803 23.8176 1.21208 23.8099 1.19607 23.8023C1.18525 23.7972 1.17433 23.7923 1.16361 23.787C1.14472 23.7777 1.12587 23.7684 1.10731 23.7585C1.09607 23.7525 1.08495 23.7463 1.07383 23.7401C1.05605 23.7303 1.03853 23.72 1.02108 23.7096C1.01004 23.703 0.999006 23.6965 0.988105 23.6897C0.73964 23.5356 0.525629 23.3307 0.361156 23.089C0.353088 23.0771 0.345651 23.0648 0.337822 23.0528C0.327842 23.0375 0.317988 23.0221 0.308402 23.0065C0.301677 22.9955 0.295149 22.9844 0.28862 22.9733C0.278291 22.9558 0.268014 22.9382 0.258186 22.9203C0.252882 22.9107 0.247616 22.901 0.242461 22.8913C0.201664 22.8143 0.166012 22.7342 0.134926 22.6518C0.129811 22.6383 0.124549 22.6248 0.119709 22.6111C0.0538897 22.4249 0.0129651 22.2268 0.0025362 22.0205C0.000737478 21.985 5.16789e-06 21.949 0 21.913V5.6999C1.14808e-05 5.55808 0.0142271 5.41955 0.0410865 5.28567C0.0515669 5.23344 0.064337 5.18202 0.0786223 5.13128C0.0835353 5.11383 0.0889962 5.09658 0.0943468 5.07931C0.0960181 5.07392 0.0971984 5.06838 0.098912 5.06301C0.106822 5.0382 0.114968 5.01352 0.123767 4.98913C0.128019 4.97735 0.132499 4.96566 0.136955 4.95397C0.143724 4.93622 0.150518 4.9185 0.157752 4.90099C0.178786 4.85007 0.202405 4.80048 0.227244 4.7517C0.231997 4.74236 0.236558 4.73293 0.241447 4.72368C0.249899 4.70768 0.258971 4.69204 0.267823 4.67629C0.277211 4.65958 0.286399 4.64278 0.296229 4.62636C0.300295 4.61957 0.304261 4.61272 0.308402 4.60598C0.321834 4.58411 0.335793 4.5626 0.349996 4.54127C0.355006 4.53375 0.36011 4.5263 0.365213 4.51885C0.377319 4.50117 0.389614 4.48365 0.402242 4.46637C0.411754 4.45336 0.421352 4.44043 0.431155 4.42765C0.44123 4.41451 0.451213 4.4013 0.461589 4.38842C0.469215 4.37895 0.477136 4.36972 0.484922 4.36039C0.5197 4.31871 0.556114 4.27846 0.593979 4.23964C0.602766 4.23064 0.611409 4.22148 0.620356 4.21264C0.660189 4.17324 0.701751 4.13561 0.74463 4.09952C0.750885 4.09426 0.75708 4.08892 0.763398 4.08373C0.861941 4.00275 0.968025 3.93065 1.08042 3.86872C1.08368 3.86692 1.0868 3.86489 1.09006 3.86311C1.17203 3.81851 1.25757 3.77981 1.34571 3.74643C1.35396 3.74331 1.36226 3.74028 1.37056 3.73726C1.5594 3.66853 1.76087 3.62625 1.97063 3.61549C2.00607 3.61367 2.04177 3.61296 2.07766 3.61294H4.11626V2.08696C4.11626 0.970502 4.98929 0.0586226 6.08689 0.00254755L6.19392 0H17.9223ZM6.19392 1.56522C5.90717 1.56536 5.6745 1.79889 5.6745 2.08696V3.61294H13.8061C14.9535 3.61294 15.8836 4.54738 15.8837 5.6999V11.2831C15.6978 11.1262 15.5109 10.9666 15.3212 10.8077C14.9803 10.5222 14.6484 10.2406 14.3255 9.9645V5.6999C14.3254 5.41183 14.0929 5.17816 13.8061 5.17816H9.26577V11.4864C8.99795 11.4858 8.65458 11.484 8.23708 11.4793C7.75631 11.4738 7.26182 11.4711 6.75493 11.4711C6.24803 11.4711 5.76938 11.4684 5.31994 11.463C4.87056 11.4575 4.5409 11.4543 4.33184 11.4543C3.87217 11.4544 3.5347 11.5337 3.3204 11.6917C3.10623 11.85 2.99884 12.1589 2.99881 12.617C2.98836 12.9553 2.98547 13.2613 2.99069 13.5341C2.99591 13.8068 2.99881 14.0906 2.99881 14.385C2.99882 14.6358 3.03532 14.8354 3.10837 14.9827C3.18148 15.1299 3.27847 15.242 3.39851 15.3184C3.51864 15.3948 3.65251 15.4465 3.79873 15.4738C3.9449 15.5011 4.08652 15.5151 4.22227 15.5151C4.5358 15.5151 4.94375 15.5178 5.44523 15.5233C5.947 15.5287 6.46528 15.5314 6.9984 15.5314C7.53146 15.5314 8.04408 15.5341 8.53534 15.5396C8.80753 15.5426 9.05132 15.5428 9.26577 15.5442V22.4348H13.8061C14.0929 22.4348 14.3254 22.2011 14.3255 21.913V17.2245C14.696 16.9188 15.0725 16.6105 15.4546 16.3008C15.5995 16.1833 15.7422 16.0659 15.8837 15.9507V18.8218H17.9223C18.2092 18.8218 18.4417 18.5882 18.4418 18.3001V2.08696C18.4418 1.79881 18.2092 1.56522 17.9223 1.56522H6.19392ZM11.0294 8.53176C11.228 8.42832 11.4793 8.50763 11.7822 8.76919C12.0958 9.03106 12.4618 9.34259 12.8799 9.70262C13.298 10.0627 13.7324 10.4313 14.1819 10.8077C14.6314 11.1842 15.0707 11.5555 15.4993 11.921C15.9278 12.2865 16.3101 12.6061 16.6446 12.8789C16.9476 13.1407 17.1018 13.3893 17.1072 13.6238C17.1124 13.8585 16.9683 14.1014 16.6755 14.3524C16.3724 14.6143 16.0141 14.9144 15.6012 15.2527C15.1882 15.591 14.7597 15.9406 14.3154 16.3008C13.871 16.6609 13.4343 17.0186 13.0057 17.3733C12.577 17.728 12.1949 18.042 11.8603 18.3149C11.4945 18.6203 11.1936 18.7347 10.9584 18.6583C10.7237 18.5817 10.6112 18.3471 10.6216 17.9547V17.0864C10.6216 16.923 10.6187 16.762 10.6135 16.6039C10.6083 16.4458 10.6059 16.3007 10.6059 16.1698C10.6059 15.8972 10.5273 15.7252 10.3705 15.6542C10.2137 15.5834 9.99898 15.5477 9.72736 15.5477C9.59229 15.5477 9.43816 15.5452 9.26577 15.5442V11.4864C9.3062 11.4865 9.34542 11.4874 9.38243 11.4874C9.77953 11.4983 10.0934 11.4627 10.3234 11.3809C10.5534 11.2991 10.6683 11.1106 10.6683 10.8159C10.6683 10.5977 10.6765 10.3384 10.6921 10.0384C10.7078 9.73832 10.7155 9.47861 10.7155 9.26036C10.726 8.87873 10.831 8.63547 11.0294 8.53176Z" fill="url(#paint0_linear_5312_11328)"/>
  <defs>
    <linearGradient id="paint0_linear_5312_11328" x1="0" y1="12" x2="20" y2="12" gradientUnits="userSpaceOnUse">
      <stop stop-color="#62AFFF"/>
      <stop offset="1" stop-color="#9C41FF"/>
    </linearGradient>
  </defs>
</svg>
      </span>
      <span class="logout-text">退出登录</span>
    </button>
  </div>
</template>

<script>
import HeaderAvatar from '@/components/HeaderAvatar/index.vue'
import Profile from '@/components/Profile/index.vue'

export default {
  components: { 
    HeaderAvatar,
    Profile
  },
  data() {
    return {
      currentPopup: null
    }
  },
  computed: {
    isLoginPage() {
      // 判断当前路由是否为登录相关页面
      const loginPaths = [
        '/store/entry',
        '/store/entry/loginPwd',
        '/store/entry/loginEmail',
        '/store/entry/loginQRCode',
        '/store/entry/forgottenPwd',
        '/store/entry/verifyCompany'
      ]
      return loginPaths.includes(this.$route.path)
    },
    showHeaderAvatar() {
      const meta = this.$route.meta || {}
      return meta.showHeaderAvatar === true
    },
    showPageLogout() {
      const meta = this.$route.meta || {}
      return meta.showHeaderAvatar === true
    }
  },
  watch: {
    // 监听路由变化，防止无限循环
    '$route'(to, from) {
      // 如果路由没有实际变化，不执行任何操作
      if (to.path === from.path) {
        return
      }
    }
  },
  methods: {
    handlePopupChange(popupType) {
      this.currentPopup = popupType;
    },
    async handleLogout() {
      try {
        await this.$store.dispatch('auth/logout')
      } finally {
        if (!this.$route.path.startsWith('/store/entry')) {
          this.$router.push('/store/entry/loginEmail')
        }
      }
    }
  }
}
</script>

<style lang="css" src="./assets/common.css"></style>
<style scoped>
.fixed-avatar {
  position: fixed;
  top: 10px;
  right: 20px;
  z-index: 2000;
}

.main-content {
  width: 100%;
}

.page-logout {
  position: fixed;
  right: 20px;
  bottom: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 14px;
  border: none;
  border-radius: 14px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.70);
  box-shadow: 1px 1px 10px rgba(0,0,0,0.05), 4px 4px 20px rgba(0,0,0,0.05);
  backdrop-filter: blur(10px);
  color: #5b3df5;
  transition: all .2s ease;
  z-index: 2000;
  overflow: hidden; /* 保证内部不溢出圆角 */
}

.page-logout:hover {
  background: rgba(255, 255, 255, 0.85);
}

.logout-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
}

.logout-text {
  font-size: 12px;
  font-weight: 600;
  color: #5b3df5;
}
</style>
